import * as yup from 'yup'

export default function policySchema(required = true) {
  if (!required) {
    return yup.boolean().nullable().label('Politique de données')
  }

  return yup
    .boolean()
    .required('Vous devez accepter la politique de données')
    .oneOf([true], 'Vous devez accepter la politique de données')
    .label('Politique de données')
}
